import { LinkedInWizardData } from "@/pages/LinkedInWizard";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
interface LinkedInWizardStep2Props {
  data: LinkedInWizardData;
  updateData: (updates: Partial<LinkedInWizardData>) => void;
  onNext: () => void;
  onPrev: () => void;
}
const PRIMARY_GOALS = ["Get hired for a new job", "Get promoted or headhunted", "Land consulting or freelance clients", "Sell a product or service", "Book speaking engagements", "Build personal brand and authority", "Grow industry network", "Attract investors or strategic partners", "Drive traffic to a website or funnel", "Recruit top talent", "Launch a new offer or business", "Be seen as a thought leader"];
export function LinkedInWizardStep2({
  data,
  updateData
}: LinkedInWizardStep2Props) {
  const toggleGoal = (goal: string) => {
    const currentGoals = data.primaryGoals || [];
    const isSelected = currentGoals.includes(goal);
    if (isSelected) {
      updateData({
        primaryGoals: currentGoals.filter(g => g !== goal)
      });
    } else {
      updateData({
        primaryGoals: [...currentGoals, goal]
      });
    }
  };
  return <div className="space-y-6">
      {/* Step Number and Header */}
      <div className="relative">
        <div className="absolute -top-2 -left-2">
          <div className="w-12 h-12 bg-linkedin rounded-full flex items-center justify-center shadow-linkedin">
            <span className="text-2xl font-bold text-white">2</span>
          </div>
        </div>
        <div className="ml-12">
          <h2 className="text-2xl font-bold mb-2 text-linkedin">What is your #1 goal with your LinkedIn profile?</h2>
          <p className="mb-6 text-base text-zinc-700">
            Select your primary objectives. You can choose multiple goals that align with your career aspirations.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {PRIMARY_GOALS.map(goal => {
        const isSelected = data.primaryGoals?.includes(goal);
        return <Card key={goal} className={`p-4 cursor-pointer transition-all hover:shadow-md border-linkedin/20 ${isSelected ? 'border-green-500 bg-green-50 dark:bg-green-950 ring-2 ring-green-200 shadow-md' : 'border-linkedin/30 bg-linkedin-light/10 hover:border-linkedin/50 hover:bg-linkedin-light/20'}`} onClick={() => toggleGoal(goal)}>
              <div className="flex items-center justify-between">
                <span className={`text-sm font-medium ${isSelected ? 'text-green-800 dark:text-green-200' : 'text-linkedin dark:text-linkedin'}`}>{goal}</span>
                {isSelected && <Badge variant="default" className="bg-green-600 hover:bg-green-700 text-white">
                    Selected
                  </Badge>}
              </div>
            </Card>;
      })}
      </div>

      {data.primaryGoals && data.primaryGoals.length > 0 && <div className="mt-6 p-4 bg-linkedin-light dark:bg-linkedin-dark/20 rounded-lg border border-linkedin/20">
          <p className="text-sm font-medium text-linkedin mb-2">
            Selected Goals ({data.primaryGoals.length}):
          </p>
          <div className="flex flex-wrap gap-2">
            {data.primaryGoals.map(goal => <Badge key={goal} variant="secondary" className="text-xs bg-white border-linkedin/20">
                {goal}
              </Badge>)}
          </div>
        </div>}
    </div>;
}